import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: any) => ({
  widgetGridItem: { minWidth: 0, width: '100%', maxWidth: '100%' },
  requestList: { display: 'flex', flexDirection: 'column', gap: theme.spacing(1.5), minWidth: 0, maxWidth: '100%' },
  requestCard: { minWidth: 0, maxWidth: '100%', overflow: 'hidden', borderRadius: 8, boxShadow: '0 1px 4px rgba(0, 0, 0, 0.14)' },
  cardHeader: {
    padding: theme.spacing(2, 2.5, 1),
    alignItems: 'center',
    minWidth: 0,
    '& .MuiCardHeader-content': { minWidth: 0 },
    '& .MuiCardHeader-action': { alignSelf: 'center', margin: 0 },
    [theme.breakpoints.down('xs')]: { padding: theme.spacing(1.5) },
  },
  avatar: { width: 44, height: 44, color: '#cc092f', backgroundColor: 'rgba(204, 9, 47, .09)' },
  heading: { fontWeight: 500, lineHeight: 1.25 },
  requestContent: {
    padding: theme.spacing(0, 2.5, 0.5),
    marginLeft: theme.spacing(7.5),
    minWidth: 0,
    overflow: 'hidden',
    '&:last-child': { paddingBottom: theme.spacing(0.5) },
    '& .MuiTypography-root + .MuiTypography-root': { marginTop: theme.spacing(0.25) },
    [theme.breakpoints.down('xs')]: { marginLeft: 0, padding: theme.spacing(0, 1.5, 0.5) },
  },
  headingRow: { display: 'flex', alignItems: 'center', gap: theme.spacing(1), flexWrap: 'wrap' },
  reasonRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: theme.spacing(0.5),
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
  },
  reasonLabel: { flexShrink: 0 },
  reasonValue: {
    display: 'flex',
    alignItems: 'baseline',
    minWidth: 0,
    flex: 1,
  },
  reasonValueExpanded: {
    display: 'block',
    minWidth: 0,
    flex: 1,
  },
  reasonPreview: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  reasonExpanded: {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  showMoreLink: {
    color: '#cc092f',
    background: 'transparent',
    border: 0,
    padding: 0,
    marginLeft: theme.spacing(0.5),
    font: 'inherit',
    cursor: 'pointer',
    verticalAlign: 'baseline',
    flexShrink: 0,
    '&:hover': { color: '#a80728' },
  },
  timer: {
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.grey[100],
    fontVariantNumeric: 'tabular-nums',
  },
  actions: {
    padding: theme.spacing(0.5, 2.5, 1.5),
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    minWidth: 0,
    [theme.breakpoints.down('xs')]: { padding: theme.spacing(1, 1.5, 1.5) },
  },
  pendingChip: { color: '#8a5a00', background: '#fff4d6' },
  expiredChip: { color: '#8a1c1c', background: '#fde8e8' },
  acceptButton: { color: '#fff', backgroundColor: '#4caf50', '&:hover': { backgroundColor: '#388e3c' } },
  rejectButton: { color: '#fff', backgroundColor: '#cc092f', '&:hover': { backgroundColor: '#a80728' } },
  deleteButton: { color: '#fff', backgroundColor: '#cc092f', '&:hover': { backgroundColor: '#a80728' } },
}));
